const reports = {
  columns: {
    id: "ID",
    property_name: "Property Name",
    completed_jobs_24: "Last 24 Hours",
    completed_jobs_week: "Last 7 Days",
    completed_jobs_month: "MTD",
    completed_jobs_year: "YTD",
  },
};

export default reports;
